"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCarouselNavControls = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CarouselNavControlsMixin = require("../../mixins/components/CarouselNavControlsMixin");
var StyledCarouselNavControls = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "StyledCarouselNavControls",
  componentId: "c11n-8-107-0__sc-1moj1il-0"
})(["", ""], _CarouselNavControlsMixin.CarouselNavControlsMixin);
exports.StyledCarouselNavControls = StyledCarouselNavControls;